import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isHomeActive = location.pathname.toLowerCase() === "/admin";
  const isUploadActive = location.pathname === "/admin/import";
  const isStatisticsActive = location.pathname === "/admin/statistics";
  const isVideoTestActive = location.pathname === "/admin/video-test";
  const isDoctorsActive = location.pathname === "/admin/doctors";
  const isLaxativesActive = location.pathname === "/admin/laxatives";

  return (
    <ContentWrapper>
      <Sidebar>
        <SidebarMenuItem $active={isHomeActive} onClick={() => navigate("/admin")}>
          <SidebarMenuText>Home</SidebarMenuText>
        </SidebarMenuItem>
        <SidebarMenuItem $active={isUploadActive} onClick={() => navigate("/admin/import")}>
          <SidebarMenuText>Upload</SidebarMenuText>
        </SidebarMenuItem>
        <SidebarMenuItem $active={isStatisticsActive} onClick={() => navigate("/admin/statistics")}>
          <SidebarMenuText>Statistics</SidebarMenuText>
        </SidebarMenuItem>
        <SidebarMenuItem $active={isVideoTestActive} onClick={() => navigate("/admin/video-test")}>
          <SidebarMenuText>Video Test</SidebarMenuText>
        </SidebarMenuItem>
        <SidebarMenuItem $active={isDoctorsActive} onClick={() => navigate("/admin/doctors")}>
          <SidebarMenuText>Doctors</SidebarMenuText>
        </SidebarMenuItem>
        <SidebarMenuItem $active={isLaxativesActive} onClick={() => navigate("/admin/laxatives")}>
          <SidebarMenuText>Laxatives</SidebarMenuText>
        </SidebarMenuItem>
      </Sidebar>

      <MainContent>{children}</MainContent>
    </ContentWrapper>
  );
}

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
`;

const Sidebar = styled.div`
  width: 280px;
  flex-shrink: 0;
  background: #f02a4c;
  padding: 1.5rem;
  color: white;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
`;

const SidebarMenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background: ${props => props.$active ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  margin-bottom: 0.5rem;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const SidebarMenuText = styled.span`
  font-size: 1rem;
  font-weight: 500;
  color: white;
`;

const MainContent = styled.div`
  flex: 1 1 0%;
  margin-left: 300px;
  padding: 2rem;
`;
